import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-locize-backend';
import {getLocizeApiKey, getLocizeProjectId} from './utils/runtimeVars';

const locizeOptions = {
  projectId: getLocizeProjectId(),
  apiKey: getLocizeApiKey(),
  referenceLng: 'en',
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
  })
  .catch((error) => {
    console.error('Failed to initialize i18n', error);
  });
